import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    SelectProps,
    styled
} from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { FieldState } from 'formstate';
import { observer } from 'mobx-react';
import * as React from 'react';

type CountryPickerProps = SelectProps & {
    countries: string[];
    field: FieldState<string>;
};

const StyledSelect = styled(Select)({
    paddingTop: 12,
    paddingBottom: 12,
    height: 32,
    boxSizing: 'content-box'
});

const MenuItemWrapper = styled('div')({
    display: 'flex'
});

const MenuItemFlag = styled('img')({
    marginRight: 14,
    height: 32,
    width: 32
});

const MenuItemCountry = styled('div')({
    display: 'flex',
    alignSelf: 'center',
    fontWeight: 'bold'
});

export const CountryPicker = observer((props: CountryPickerProps) => {
    const { countries, field, label, ...rest } = props;
    const { error } = field;
    const { translate, country } = injectTSDI(I18nStore);

    React.useEffect(() => {
        if (!country) {
            return;
        }
        if (country === 'GB') {
            field.value = 'UK';
            return;
        }
        field.value = countries.includes(country) ? country : '';
    }, [countries, country, field]);

    return (
        <FormControl error={!!error} fullWidth variant="outlined">
            <InputLabel required>{label}</InputLabel>
            <StyledSelect
                autoComplete="country-name"
                onBlur={() => field.validate()}
                value={field.value}
                onChange={(e) => field.onChange(e.target.value as string)}
                label={`${label} *`}
                inputProps={{
                    'data-role': 'country'
                }}
                {...rest}
            >
                {countries?.map((option) => (
                    <MenuItem key={option} value={option}>
                        <MenuItemWrapper>
                            <MenuItemFlag src={`/assets/flags/${option}.png`} />{' '}
                            <MenuItemCountry>
                                {translate(`country.${option.toLowerCase()}`)}
                            </MenuItemCountry>
                        </MenuItemWrapper>
                    </MenuItem>
                ))}
            </StyledSelect>
            <FormHelperText>{error || ' '}</FormHelperText>
        </FormControl>
    );
});
